const GUIDED_ASSISTANT_QUOTE_STORAGE_KEY = 'guided-assistant-quote-by-org'

export function getStoredGuidedAssistantQuotePublicId(orgId?: string | null) {
  if (!orgId) return null

  try {
    const raw = localStorage.getItem(GUIDED_ASSISTANT_QUOTE_STORAGE_KEY)
    if (!raw) return null

    const map = JSON.parse(raw) as Record<string, string>
    return map[orgId] ?? null
  } catch {
    return null
  }
}

export function setStoredGuidedAssistantQuotePublicId(
  orgId: string,
  publicId: string
) {
  try {
    const raw = localStorage.getItem(GUIDED_ASSISTANT_QUOTE_STORAGE_KEY)
    const map = raw ? (JSON.parse(raw) as Record<string, string>) : {}
    map[orgId] = publicId
    localStorage.setItem(GUIDED_ASSISTANT_QUOTE_STORAGE_KEY, JSON.stringify(map))
  } catch {
    // ignore storage failures
  }
}

export function clearStoredGuidedAssistantQuotePublicId(orgId: string) {
  try {
    const raw = localStorage.getItem(GUIDED_ASSISTANT_QUOTE_STORAGE_KEY)
    if (!raw) return

    const map = JSON.parse(raw) as Record<string, string>
    delete map[orgId]
    localStorage.setItem(GUIDED_ASSISTANT_QUOTE_STORAGE_KEY, JSON.stringify(map))
  } catch {
    // ignore storage failures
  }
}
